import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.375 1A7.848 7.848 0 0 0 3.2 2.95L.5.25V7h6.75L4.535 4.285a5.965 5.965 0 0 1 3.84-1.41A6.009 6.009 0 0 1 14.075 7l1.777-.585C14.81 3.272 11.862 1 8.375 1Z",
  fill: "#616161"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };